import axios from 'axios';
import { mutate } from 'swr';

import { Notistack } from '@shared/components/Notistack/Notistack';
import { SERVICES } from '@shared/constants/apiConfig';
import { getError } from '@shared/utils/helpers';
import { LienHolderAddress } from './interfaces';

const BASE_URL = `/${SERVICES.ASSET}/lienholder`;

export const requestCreateAddress = async(data: LienHolderAddress) => {
    try {
      await axios.post(`${BASE_URL}/lienHolder`, data);
      Notistack.successMessage('Address - Created Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));

      throw err;
    }
};

export const requestUpdateAddress = (data: LienHolderAddress) => {
  return mutate(BASE_URL, async() => {
    try {
      await axios.put(`${BASE_URL}/lienHolder`, data);

      Notistack.successMessage('Address - Updated Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));

      throw err;
    }
  });
};

export const requestDeleteAddress = (id: string) => {
  return mutate(BASE_URL, async() => {
    try {
      await axios.delete(`${BASE_URL}/${id}`);

      Notistack.successMessage('Address - Deleted Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};
